import React, { memo } from "react";
import { withAppState, getAppState } from "../../state";
import { directions, i18n } from "../../services/i18nService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Epg, LiveHero, ModalSettings, Loading, Text } from "../../services/visualLibraryService";
import { resolution } from "../../config/ui/resolutionConfig";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import { isUserAccountActive } from "../../services/accountStatusService";
import { routes } from "../../routes";
import { redirectTo } from "../../services/navigationService";
import { config } from "../../config/config";
import { LayoutStyled, ArrowScrollStyled, StyledPage, WrapperStyled } from "./styles/Styled";
import { isSuitableFor4KPlayback, has4KProgramId } from "../../services/titleDataService";
import { getGlobalButtonFocusPath, getConfigForModalWithCloseButton } from "../../errors/globalButtons";
import {
  isUserSubscribedToChannel,
  isAddonContent,
  getInActiveSubscriptionDisplayName,
  isChampionsTrophyAddOn
} from "../../utils/subscriptionUtils";
import { showResolutionModal, showNotLoggedModal, showSignupPremiumPrompt } from "../../services/modalsService";
import { getNavigationReferences } from "../../services/navigationService";
import { getSdk } from "../../services/sdkService";
import { getUnixTime, getEpgTime, getHoursFromUnix, getMinutesFromUnix } from "../../utils/timeStamp";
import { getNumericParentalLevel } from "../../services/parentalControlService";
import {
  sameLayoutRequestIsInProgress,
  setLayoutRequestInProgress,
  unsetLayoutRequestInProgress
} from "../Layout/layoutNetworkUtils";
import { getPath } from "../../utils/getPath";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { starzRevamp as Theme } from "starz-visual-themes";
import { CellMeasurer, CellMeasurerCache, List } from "react-virtualized";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { FilterCarasoulStyled, LayoutWrapperStyled } from "./styles/Styled";
import { LayoutEmptyStyled } from "../Layout/styles/Styled";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { ButtonStyled } from "../../components/ModalSettings/styles/Styled";
import { redirectToBuyBrandsPage, getBuyBrandsActivateDisplayName } from "../../utils/tvodUtils";
import { getMultiTaggedAddOnContent } from "../../utils/addOnsUtil";
import { isHidePromptForKidsProfile } from "../../utils/promptUtils";
import { STARZ } from "../../utils/mediaDataRetrieval";

//const defaultFocusPath = Epg.defaultFocusPath;
let sdk = null;
const TIME_TO_MILLISECONDS = 1000;
const SECONDS_PER_PIXELS = 10.75;
const LG_HIGHER_VERSIONS = 4;
const TOTAL_TIME_HOURS = 30;
const TOTAL_REDUCE_TIME_HOURS = 9;
const CLICK_POSTER_DELAY_DEFAULT = 50;
const CLICK_POSTER_DELAY_LOW_END = 50;
const PLAY_FROM_LABEL = "live_screen";
const ButtonModalFocus = withFocusable(ButtonStyled);
const INITIAL_MODULE = 0;
let epgStartIndex = 0;
let amountOfDownloadedModules = {};
const width = window.innerWidth;
const height = window.innerHeight;
//let signupInactivePromptTimer = null;

const ListReferenced = props => {
  return (
    <List ref={list => (listRef = list)} {...props}>
      {props.children}
    </List>
  );
};
const ListFocus = withFocusable(ListReferenced);
let listRef = null;
const epgListName = "lists";
const epgGridName = "epg";
let progress = 0;
let remainingTime = null;
let carousalSlider;
let currentEPGColumnIndex;

class Live extends React.PureComponent {
  constructor(props) {
    super(props);
    this.epgEvents = React.createRef();
    this.state = {
      filter: "all",
      epgData: null,
      channelTitle: null,
      isExiting: false,
      program: null,
      imageUrl: null,
      text: null,
      channelsStatus: null,
      modules: null,
      nameSection: getPath(this.props),
      subscriptions: getAppState().subscriptions,
      carousalIndex: 0,
      carousalListIndex: 0,
      loading: false,
      showLiveCarousel: true,
      hasMediaContentId: false,
      selectedliveTvList: -1
    };
    this.switchMainMenuUpDown = this.switchMainMenuUpDown.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.navigateLeft = this.navigateLeft.bind(this);
    this.navigateRight = this.navigateRight.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getEpgFilters = this.getEpgFilters.bind(this);
    this.getEpgData = this.getEpgData.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.getEpgRefreshEvent = this.getEpgRefreshEvent.bind(this);
    this.onClickPoster = this.onClickPoster.bind(this);
    this.isLiveProgram = this.isLiveProgram.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.play = this.play.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.programData = this.programData.bind(this);
    this.onBack = this.onBack.bind(this);
    this.clearRefreshTimeout = null;
    this.isEpgRefreshed = false;
    this.item = null;
    this.isliveCarosals = false;
    this.startIndex = 0;
    this.getPlatform = null;
    this.signupInactivePromptTimer = null;
    this.getLayout = this.getLayout.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.onChangeItem = this.onChangeItem.bind(this);
    this.cache = new CellMeasurerCache({
      defaultHeight: height / 3,
      fixedWidth: true,
      keyMapper: (rowIndex, columnIndex) => {
        const data = this.state.modules?.modules[rowIndex];
        return `${data?.id}`;
      }
    });
    this.wheelState = "idle";
    this.videoData = null;
    this.epgPreviousHoursFromCurrentHour = null;
    this.epgNextHoursFromCurrentHour = null;
    this.egpStartTimeMilliSeconds = null;
    this.egpEndTimeMilliSeconds = null;

    this.TypedCarouselStyledMemo = memo(
      props => {
        return <TypedCarouselStyled onClickPoster={i => this.onClickPoster(i, "live")} {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className
        );
      }
    );
    this.FilterCarasoulStyledMemo = memo(
      props => {
        return <FilterCarasoulStyled {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className
        );
      }
    );
  }
  async scrollUpDown(event, from) {
    this.wheelState = "active";
    if (event.deltaY > 0) {
      // down wheel move
      !from && this.onModulesDown();
      await this.reloadWait(10);
      this.epgEvents.current.onDown();
    } else if (event.deltaY < 0) {
      // up wheel moves
      !from && this.onModulesUp();
      from && this.epgEvents.current.onUp();
    }
  }

  componentWillUnmount() {
    this.props.stateActions.setLastFocusedName("");
    document.removeEventListener("keydown", this.switchMainMenuUpDown, false);
    document.removeEventListener("keydown", this.enterHandler, false);
    this.resetComponentData();
    if (this.signupInactivePromptTimer) {
      clearTimeout(this.signupInactivePromptTimer);
    }
  }

  async onClickPoster(itemIndex, from) {
    const { history } = this.props;

    if (from === "epg") {
      await this.reloadWait(10);
      const isArrowClicked = this.epgEvents?.current?.state?.isArrowClicked || false;
      if (isArrowClicked) return;
      const row = this.epgEvents?.current?.state?.currentliveTvIndex;
      const col = this.epgEvents?.current?.state?.selectedProgram;

      history.replace({
        state: {
          rowIndex: row,
          colIndex: col,
          scrollToPage: 2
        }
      });
      this.setState({
        hasMediaContentId: false,
        focusOn: epgGridName
      });
      this.isliveCarosals = false;
      this.props.setFocus(epgGridName);
      this.programData(col, row);
      await this.handleEpgKeyPress();
    } else if (from === "live") {
      const { location } = this.props;
      if (location?.state?.scrollToPage === -1) {
        this.intializeFocus();
        this.onModulesDown();
      }
      this.isliveCarosals = true;
      carousalSlider.goTo(itemIndex);
      this.props.stateActions.setCarouselItemFocus(itemIndex);
      await this.reloadWait(10);

      const { id, addonContent } = this.getVideoDataForLiveCarousel();
      id &&
        this.setState({
          hasMediaContentId: true,
          focusOn: epgListName
        });
      await this.playHandler(addonContent);
    }
  }

  resetComponentData = () => {
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;
    this.isEpgRefreshed = false;
    this.item = null;
    this.isliveCarosals = false;
    this.getPlatform = null;
    this.videoData = null;
    this.epgPreviousHoursFromCurrentHour = null;
    this.epgNextHoursFromCurrentHour = null;
    this.egpStartTimeMilliSeconds = null;
    this.egpEndTimeMilliSeconds = null;
  };

  componentDidUpdate(prevProps, prevState) {
    const { isExiting } = this.state;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.reloadWait(500);
    const { onRef } = this.props;
    document.addEventListener("keydown", this.switchMainMenuUpDown, false);
    document.addEventListener("keydown", this.enterHandler, false);
    onRef && onRef(this);
    await this.loadLivePageData();
    this.setState({ loading: false });
    // check history
    if (this.props.location.referrer === "/player") {
      if (sessionStorage.getItem("fromEpg") === "yes") {
        await this.intializeFocusonEpg();
        return;
      }
    }
    this.isliveCarosals = true;
    this.intializeFocus();
    this.props.setFocus(epgListName);
    this.props.stateActions.setLastFocusedName(epgListName);
    const isHidePromptForkids = await isHidePromptForKidsProfile();
    if (getAppState()?.signupPromptActive && !getAppState()?.userLogged && !isHidePromptForkids) {
      this.startSignupInactivePromptTimer();
    }
  }

  startSignupInactivePromptTimer = () => {
    if (this.signupInactivePromptTimer !== null) clearTimeout(this.signupInactivePromptTimer);
    this.signupInactivePromptTimer = setTimeout(() => {
      showSignupPremiumPrompt.call(this, getNavigationReferences.call(this), this.closeModal);
    }, getAppState().signupPromptTimer || 5000);
  };

  createTimeDictionary() {
    const startDate = new Date(this.egpStartTimeMilliSeconds * TIME_TO_MILLISECONDS);
    const endDateTime = new Date(this.egpEndTimeMilliSeconds * TIME_TO_MILLISECONDS)?.getTime();
    let timeDictionary = new Object();

    let timeValue = startDate?.getTime();
    while (timeValue <= endDateTime) {
      timeDictionary[`${startDate.getDate()}-${startDate.getHours()}`] = timeValue;
      timeValue = new Date(startDate.setMinutes(startDate.getMinutes() + 60))?.getTime();
    }
    return timeDictionary;
  }

  populateTimeDictionary(dictionary, events) {
    let updatedDictionary = { ...dictionary };
    Object.entries(updatedDictionary).forEach(([key]) => {
      const indexArr = [];
      events.forEach((event, index) => {
        const eventStartTime = event?.tsStart * TIME_TO_MILLISECONDS;
        const eventStartDate = new Date(eventStartTime);
        const eventStartDateKey = `${eventStartDate?.getDate()}-${eventStartDate?.getHours()}`;
        if (eventStartDateKey === key) {
          indexArr.push(index);
        }
      });
      updatedDictionary[key] = indexArr;
      updatedDictionary = this.populateEmptyArrays(updatedDictionary);
    });
    return updatedDictionary;
  }

  populateEmptyArrays(dictionary) {
    const updatedDictionary = { ...dictionary };
    let starterIndex = 0;
    Object.entries(updatedDictionary).forEach(([key, value]) => {
      if (value.length === 0) {
        value.push(starterIndex);
      }
      starterIndex = value[value.length - 1];
    });
    return updatedDictionary;
  }

  createEpgDictionary() {
    let epgDictionary = new Object();
    for (let [channelIndex, items] of this.state.epgData?.data?.entries()) {
      let timeDictionary = this.createTimeDictionary();
      const updatedDictionary = this.populateTimeDictionary(timeDictionary, items?.events);
      epgDictionary[channelIndex] = updatedDictionary;
    }
    this.setState({ epgDictionary: epgDictionary });
  }

  async loadLivePageData() {
    /* Get Layout call(nms) to decide the components to load */
    this.epgPreviousHoursFromCurrentHour = -6;
    this.epgNextHoursFromCurrentHour = 24;

    this.egpStartTimeMilliSeconds = getUnixTime(getEpgTime(this.epgPreviousHoursFromCurrentHour));
    this.egpEndTimeMilliSeconds = getUnixTime(getEpgTime(this.epgNextHoursFromCurrentHour));

    await this.getLayout();
    /* Get Filter  Data */
    this.setState({
      epgData: ""
    });
    const epgData = await this.getEpgData("all");
    epgData &&
      this.setState({ epgData: await this.stuffData(epgData) }, () => {
        this.createEpgDictionary();
      });
    this.isEpgRefreshed = false;
  }
  async intializeFocus() {
    this.props.resumeNavigation();
    this.props.history.replace({
      state: {
        scrollToPage: -1,
        selectedliveTvList: -1
      }
    });
  }

  async intializeFocusonEpg() {
    this.props.pauseNavigation();
    this.props.history.replace({
      state: {
        scrollToPage: 2,
        selectedliveTvList: 0,
        rowIndex: 0,
        colIndex: currentEPGColumnIndex >= 0 ? currentEPGColumnIndex : epgStartIndex
      }
    });

    this.props.setFocus(epgGridName);
    this.programData(currentEPGColumnIndex >= 0 ? currentEPGColumnIndex : epgStartIndex, 0);
    this.setState({ forceRender: new Date() });
  }

  async getLayout(initialModule = INITIAL_MODULE, finalModule = 2, refreshLayout = false) {
    const {
      applicationState: { userRelatedModules, country },
      stateActions: { showGlobalModal }
    } = this.props;
    sdk = await getSdk();

    if (getAppState().isOnline) {
      if (!sameLayoutRequestIsInProgress(initialModule, finalModule)) {
        try {
          setLayoutRequestInProgress(initialModule, finalModule);
          const modules = await sdk.mediaManager.getLayout(this.state.nameSection, {
            initialModule,
            finalModule,
            ...(!!userRelatedModules &&
              userRelatedModules[`${this.state.nameSection}`] &&
              userRelatedModules[`${this.state.nameSection}`].length && {
                avoidCacheFor: userRelatedModules[`${this.state.nameSection}`]
              }),
            ...(refreshLayout === true && { refreshLayout }),
            country
          });

          let showLiveCarousel = true;
          let filteredArray = modules.modules.reduce(function(filtered, module) {
            switch (module.category) {
              case "ListLiveChannels":
                module.type = "LiveChannels";
                if (module?.titles.length === 0) showLiveCarousel = false;
                module?.titles.length !== 0 && filtered.push(module);
                break;
              default:
                filtered.push(module);
            }
            return filtered;
          }, []);

          modules.modules = [...filteredArray];
          unsetLayoutRequestInProgress();
          amountOfDownloadedModules[this.state.nameSection] = modules.modules.filter(module => !!module.titles).length;
          this.setState({ modules });
          this.setState({ showLiveCarousel: showLiveCarousel });
          this.props.applicationState.userRelatedModules = this.getUserRelatedModulesIndexes();
        } catch (error) {
          unsetLayoutRequestInProgress();
          console.log(error);
          this.setState({ loading: false });
        }
      }
    }
  }

  isEnabled = () => !!this.state.modules;
  getUserRelatedModulesIndexes() {
    let {
      applicationState: { userRelatedModules }
    } = this.props;
    if (!userRelatedModules && this.state.modules) {
      const userModulesIndexes = [];
      for (let i = 0; i < this.state.modules.modules.length; i++) {
        this.state.modules.modules[i].isDynamic === true && userModulesIndexes.push(i);
      }
      if (userModulesIndexes.length > 0) {
        this.props.applicationState.userRelatedModules = {};
        return Object.assign(this.props.applicationState.userRelatedModules, {
          [`${this.state.nameSection}`]: userModulesIndexes
        });
      }
    }
    return userRelatedModules;
  }

  async stuffData(epgData) {
    let stuffedEpgData = null;
    const {
      applicationState: { userLogged, addons }
    } = this.props;
    for (let [index] of epgData?.data?.entries()) {
      if (userLogged) {
        const addOnData = epgData.data[index];
        let subscriptionName = epgData.data[index].parent_slug
          ? epgData.data[index].parent_slug
          : epgData.data[index].slug;
        let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, subscriptionName, addOnData.subscription);

        const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
          this,
          isUserSubscribedToAsset,
          subscriptionName,
          addOnData.subscriptionPerCountry
        );
        isUserSubscribedToAsset = isUserSubscribedToChannel(addons, multiTaggedAddOnContent, addOnData.subscription);

        if (isUserSubscribedToAsset) {
          epgData.data[index].isAddonContent = true;
          epgData.data[index].rowIndex = index;
        } else {
          epgData.data[index].isAddonContent = false;
          epgData.data[index].rowIndex = index;
        }
      } else {
        epgData.data[index].isAddonContent = true;
        epgData.data[index].rowIndex = index;
      }
    }

    for (let [index, items] of epgData?.data?.entries()) {
      //start
      let hourAtStart = getHoursFromUnix(items.events[0].tsStart);
      let minsAtStart = getMinutesFromUnix(items.events[0].tsStart);
      if (
        hourAtStart >
          (getEpgTime(this.epgPreviousHoursFromCurrentHour).getHours() === 0
            ? 24
            : getEpgTime(this.epgPreviousHoursFromCurrentHour).getHours()) ||
        minsAtStart > getEpgTime(this.epgPreviousHoursFromCurrentHour).getMinutes()
      ) {
        let blankNode = {
          tsStart: this.state.startFrom,
          tsEnd: items.events[0].tsStart,
          title: i18n.get("pages.livePage.eventStatus.noprogram"),
          isBlankNode: true
        };
        epgData.data[index].events.unshift(blankNode);
      }
      //end
      let hoursAtEnd = getHoursFromUnix(items.events[items.events.length - 1].tsEnd);
      let minsAtEnd = getMinutesFromUnix(items.events[items.events.length - 1].tsEnd);
      if (
        hoursAtEnd <
          (getEpgTime(this.epgNextHoursFromCurrentHour).getHours() === 0
            ? 24
            : getEpgTime(this.epgNextHoursFromCurrentHour).getHours()) ||
        minsAtEnd < getEpgTime(this.epgNextHoursFromCurrentHour).getMinutes()
      ) {
        let blankNode = {
          tsStart: items.events[items.events.length - 1].tsEnd,
          tsEnd: this.state.endTill,
          title: i18n.get("pages.livePage.eventStatus.noprogram"),
          isBlankNode: true
        };

        epgData.data[index].events.push(blankNode);
      }
    }

    for (let [channelIndex, items] of epgData.data.entries()) {
      items.events.forEach((item, index) => {
        if (index !== 0 && index !== items.events.length - 1) {
          let hour = getHoursFromUnix(item.tsEnd);
          let mins = getMinutesFromUnix(item.tsEnd);
          let nextHour = getHoursFromUnix(items.events[index + 1].tsStart);
          let nextMins = getMinutesFromUnix(items.events[index + 1].tsStart);
          if (hour !== nextHour || mins !== nextMins) {
            let blankNode = {
              tsStart: item.tsEnd,
              tsEnd: items.events[index + 1].tsStart,
              title: i18n.get("pages.livePage.eventStatus.noprogram"),
              isBlankNode: true
            };
            epgData.data[channelIndex].events.splice(index + 1, 0, blankNode);
          }
        }
      });
    }

    stuffedEpgData = epgData;
    this.clearRefreshTimeout && clearTimeout(this.clearRefreshTimeout);
    this.getEpgRefreshEvent(stuffedEpgData);
    return stuffedEpgData;
  }

  async getEpgRefreshEvent(allEvents) {
    const currentDate = new Date();
    let liveArray = [];
    allEvents &&
      allEvents.data.length > 0 &&
      allEvents.data.map((channelEvents, index) => {
        channelEvents &&
          channelEvents.events &&
          channelEvents.events.length > 0 &&
          channelEvents.events.map((item, i) => {
            if (this.isLiveProgram(item.tsStart, item.tsEnd)) {
              liveArray.push(item.tsEnd);
            }
          });
      });
    const smallestProgramMilliSeconds = Math.min(...liveArray) * 1000;
    const endDate = new Date(smallestProgramMilliSeconds);
    const refreshTime = (endDate.getTime() - currentDate.getTime()) / 1000;
    if (refreshTime > 0) {
      await this.reloadWait(refreshTime * 1000);
      await this.reloadLivePageData();
      this.setState(() => ({ forceRender: new Date() }));
    }
  }
  async reloadLivePageData() {
    const globalModal = getAppState().globalModal;
    this.isEpgRefreshed = true;
    this.setState({
      loading: true,
      isExiting: false
    });
    sessionStorage.setItem("fromEpg", "no");
    // sessionStorage.setItem('filterIndex',0);
    this.setState({ carousalIndex: 0 });
    this.props.applicationState.focusedCarouselItemIndex = 0;
    globalModal && this.props.stateActions.hideGlobalModal();
    await this.loadLivePageData();
    this.isliveCarosals = true;
    this.props.history.replace({
      state: {
        scrollToPage: -1,
        selectedliveTvList: -1
      }
    });
    this.setState(() => ({ loading: false, selectedliveTvList: -1 }));
    this.props.setFocus(epgListName);
  }
  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }

  isLiveProgram(startTime, endTime) {
    const today = new Date();
    let isLive = false;
    if (today >= startTime * TIME_TO_MILLISECONDS && today < endTime * TIME_TO_MILLISECONDS) {
      isLive = true;
    }
    return isLive;
  }

  async getEpgFilters() {
    sdk = await getSdk();
    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      try {
        let filters = await sdk.mediaManager.getChannelConfig();
        return filters?.data;
      } catch (error) {
        console.log(error);
        this.setState({ loading: false });
      }
    } else {
    }
  }
  async getEpgData(filter) {
    sdk = await getSdk();
    this.setState({
      startFrom: this.egpStartTimeMilliSeconds,
      endTill: this.egpEndTimeMilliSeconds
    });
    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      try {
        const epg = await sdk.mediaManager.getChannelEvents({
          channels: filter || "all",
          ts_start: this.state.startFrom,
          ts_end: this.state.endTill,
          lang: i18n.getLocale() || "en",
          pg: getNumericParentalLevel(),
          limit: 9000 // TODO: apply pagination
        });
        this.setState({ loading: false });
        return epg;
      } catch (error) {
        this.setState({ loading: false });
        console.log(error);
      }
    }
  }

  initializeContentFocus(event) {
    if (this.props.applicationState.lastFocusedName === "epg") {
      event.preventDefault();
      event.stopPropagation();
      this.props.pauseNavigation();
      this.intializeFocusonEpg();
      return;
    }
    this.props.resumeNavigation();
    this.isliveCarosals = true;
    this.intializeFocus();
  }

  switchMainMenuUpDown = event => {
    this.wheelState = "idle";
    if (this.state.loading) return;
    if (this.props.applicationState.currentFocus.indexOf("Modal") > -1) {
      this.props.resumeNavigation();
      return;
    }
    if (event.keyCode === 38 || event.keyCode === 40) {
      if (this.props.applicationState.currentFocus === "mainMenu") {
        return true;
      }
    }
    if (event.keyCode === 38) {
      event.preventDefault();
      event.stopPropagation();
      this.onModulesUp();
    }
    if (event.keyCode === 40) {
      event.preventDefault();
      event.stopPropagation();
      this.onModulesDown();
    }
    if (this.props.applicationState.currentFocus === epgGridName) {
      if (event.keyCode === 39) {
        event.preventDefault();
        event.stopPropagation();
        if (i18n.getDirection() === directions.LEFT_TO_RIGHT) {
          this.onModulesRight();
        } else {
          this.onModulesLeft();
        }
      }
      if (event.keyCode === 37) {
        if (i18n.getDirection() === directions.LEFT_TO_RIGHT) {
          this.onModulesLeft();
        } else {
          this.onModulesRight();
        }
        event.preventDefault();
        event.stopPropagation();
      }
    } else if (event.keyCode === 39 && i18n.getDirection() === directions.LEFT_TO_RIGHT) {
      this.initializeContentFocus(event);
    } else if (event.keyCode === 37 && i18n.getDirection() !== directions.LEFT_TO_RIGHT) {
      this.initializeContentFocus(event);
    }
  };

  enterHandler = event => {
    this.wheelState = "idle";
    if (event.keyCode === 13) {
      if (
        this.props.applicationState.currentFocus.indexOf("section") >= 0 ||
        this.props.applicationState.currentFocus === epgGridName
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
          hasMediaContentId: false,
          focusOn: epgGridName
        });

        this.handleEpgKeyPress();
      } else if (this.props.applicationState.currentFocus === epgListName) {
        // live carosal player starts from here
        event.preventDefault();
        event.stopPropagation();
        const { id, addonContent } = this.getVideoDataForLiveCarousel();
        id &&
          this.setState({
            hasMediaContentId: true,
            focusOn: epgListName
          });
        this.playHandler(addonContent);
      }
    }
    if (event.keyCode === 38 && this.props.applicationState.currentFocus === epgGridName) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  closeConfirmModal() {
    const { location } = this.props;
    this.setState({ isExiting: false });
    if (location?.state?.scrollToPage <= 0) {
      this.isliveCarosals = true;
      this.props.setFocus(epgListName);
    } else {
      this.props.setFocus(epgGridName);
    }
  }

  onBack() {
    const { stateActions } = this.props;
    const globalModal = getAppState().globalModal;
    !!globalModal && stateActions.hideGlobalModal();
    if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
      this.props.setFocus(headerFocusPath);
    } else if (this.props.applicationState.currentFocus === "mainMenu") {
      if ((!globalModal || globalModal.dismissable) && config.get().featureToggles.exitAppPopup) {
        this.setState({ isExiting: true });
      }
    } else {
      this.isliveCarosals = false;
      this.props.setFocus(headerFocusPath);
    }
    this.props.resumeNavigation();
    return true;
  }

  onModulesUp() {
    if (
      getAppState().globalModal ||
      this.state.isExiting === true ||
      this.props.applicationState.currentFocus === "mainMenu"
    )
      return;
    getSdk().systemManager.application.checkMagicRemote()
      ? this.setState({ isWheel: true })
      : this.setState({ isWheel: false });
    const { history, location } = this.props;
    if (location?.state?.scrollToPage === 2) {
      if (location?.state?.selectedliveTvList === -1 || location?.state?.selectedliveTvList === 0) {
        this.props.resumeNavigation();
        this.props.stateActions.setCarouselItemFocus(0);
        this.isliveCarosals = true;
        history.replace({
          state: {
            selectedliveTvList: -1,
            scrollToPage: 0
          }
        });
        this.props.setFocus(epgListName);
        this.props.stateActions.setLastFocusedName(epgListName);
        this.setState({ forceRender: new Date() });
      }
    }
  }

  onModulesRight() {
    if (this.props.applicationState.currentFocus === "mainMenu") {
    }
  }

  onModulesLeft() {
    if (currentEPGColumnIndex === 0) {
      this.props.history.replace({
        state: {
          scrollToPage: -1,
          selectedliveTvList: -1
        }
      });
      this.isliveCarosals = false;
      this.props.resumeNavigation();
      this.props.stateActions.setLastFocusedName(epgGridName);
      this.props.setFocus(headerFocusPath);
      this.setState({ forceRender: new Date() });
      return;
    }
  }

  onModulesDown() {
    if (
      getAppState().globalModal ||
      (this.state && this.state.isExiting === true) ||
      this.props.applicationState.currentFocus === "mainMenu"
    )
      return;
    getSdk().systemManager.application.checkMagicRemote()
      ? this.setState({ isWheel: true })
      : this.setState({ isWheel: false });
    const { history, location } = this.props;
    if (
      (location?.state?.scrollToPage === 0 ||
        location?.state?.scrollToPage === "undefined" ||
        location?.state?.scrollToPage === -1) &&
      this.state.epgData?.data?.length !== 0
    ) {
      this.props.pauseNavigation();
      this.props.setFocus(epgGridName);
      this.props.stateActions.setLastFocusedName(epgGridName);
      this.isliveCarosals = false;
      history.replace({
        state: {
          selectedliveTvList: 0,
          scrollToPage: 2
        }
      });
    }
  }
  remTime = (startTime, endTime) => {
    const today = new Date();
    const startTime1 = new Date(startTime * TIME_TO_MILLISECONDS);
    const endTime1 = new Date(endTime * TIME_TO_MILLISECONDS);
    const differenceProgramMili = endTime1.getTime() - startTime1.getTime();

    const remMili = endTime1.getTime() - today.getTime();
    let time1 = new Date(remMili);
    let hoursRem = time1.getUTCHours();
    let minutesRem = time1.getUTCMinutes();
    let secondsRem = time1.getUTCSeconds();
    if (secondsRem > 0) {
      minutesRem += 1;
    }

    const totalProgramMinutes = Math.round(differenceProgramMili / 60000);
    const minutes = hoursRem * 60 + minutesRem;
    progress = ((totalProgramMinutes - minutes) * 100) / totalProgramMinutes;

    let remStr = "";
    if (minutesRem === 0 && hoursRem === 0 && secondsRem === 0) {
      remStr = "";
    } else if (minutesRem === 1 && hoursRem === 0) {
      remStr = i18n.get("pages.livePage.time.oneleft");
    } else if (minutesRem === 2 && hoursRem === 0) {
      remStr = i18n.get("pages.livePage.time.twoleft");
    } else if (minutesRem >= 3 && minutesRem <= 10 && hoursRem === 0) {
      remStr = i18n.get(`pages.livePage.time.threeleft`, minutesRem);
    } else if (minutesRem === 60 && hoursRem === 0) {
      remStr = i18n.get("pages.livePage.time.hourleft");
    } else if (minutesRem >= 11 && hoursRem === 0 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.minleft`, minutesRem);
    } else if (minutesRem === 0 && hoursRem === 1) {
      remStr = i18n.get("pages.livePage.time.hourleft");
    } else if (minutesRem === 1 && hoursRem === 1) {
      remStr = i18n.get("pages.livePage.time.hourmin");
    } else if (minutesRem === 2 && hoursRem === 1) {
      remStr = i18n.get(`pages.livePage.time.hourmins`, minutesRem);
    } else if (minutesRem >= 3 && minutesRem <= 10 && hoursRem === 1 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.onehours`, minutesRem);
    } else if (minutesRem >= 11 && hoursRem === 1 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.hor`, minutesRem);
    } else if (minutesRem === 60 && hoursRem === 1) {
      remStr = i18n.get(`pages.livePage.time.h`);
    } else if (minutesRem === 1 && hoursRem === 2) {
      remStr = i18n.get(`pages.livePage.time.hm`);
    } else if (minutesRem === 2 && hoursRem === 2) {
      remStr = i18n.get(`pages.livePage.time.hsms`);
    } else if (minutesRem >= 3 && minutesRem <= 10 && hoursRem === 2) {
      remStr = i18n.get(`pages.livePage.time.hors`, minutesRem);
    } else if (minutesRem >= 11 && hoursRem === 2 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.twohours`, minutesRem);
    } else if (hoursRem >= 2 && hoursRem <= 10 && minutesRem === 60) {
      remStr = i18n.get(`pages.livePage.time.threehour`, hoursRem + 1);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem === 1) {
      remStr = i18n.get(`pages.livePage.time.threeone`, hoursRem);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem === 2) {
      remStr = i18n.get(`pages.livePage.time.threetwo`, hoursRem);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem >= 3 && minutesRem <= 10) {
      remStr = i18n.get(`pages.livePage.time.three`, hoursRem, minutesRem);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem >= 11) {
      remStr = i18n.get(`pages.livePage.time.three`, hoursRem, minutesRem);
    } else if (hoursRem >= 10 && minutesRem === 60) {
      remStr = i18n.get(`pages.livePage.time.ele`, hoursRem + 1);
    } else if (hoursRem >= 11 && minutesRem === 1) {
      remStr = i18n.get(`pages.livePage.time.eleone`, hoursRem);
    } else if (hoursRem >= 11 && minutesRem === 2) {
      remStr = i18n.get(`pages.livePage.time.eletwo`, hoursRem);
    } else if (hoursRem >= 11 && minutesRem >= 3 && minutesRem <= 10) {
      remStr = i18n.get(`pages.livePage.time.elethree`, hoursRem, minutesRem);
    } else if (hoursRem >= 11 && minutesRem >= 11) {
      remStr = i18n.get(`pages.livePage.time.eleplus`, hoursRem, minutesRem);
    }
    return remStr;
  };

  programStatus = (startTime, endTime, title, previousProgram) => {
    let type = "";
    const start = startTime * TIME_TO_MILLISECONDS;
    const end = endTime * TIME_TO_MILLISECONDS;
    const today = Date.now();
    if (title === i18n.get("pages.livePage.eventStatus.noprogram")) {
      type = type;
    } else if (today >= start && today < end) {
      type = i18n.get("pages.livePage.eventStatus.live");
      remainingTime = this.remTime(startTime, endTime);
    } else if (today >= start && today >= end) {
      type = i18n.get("pages.livePage.eventStatus.catchup");
    } else if (today <= start && today < end) {
      type =
        previousProgram?.status === "live"
          ? i18n.get("pages.livePage.eventStatus.upnext")
          : previousProgram?.status == null
          ? i18n.get("pages.livePage.eventStatus.upnext")
          : "";
    }
    return type;
  };

  isLiveProgram = (startTime, endTime) => {
    const start = startTime * TIME_TO_MILLISECONDS;
    const end = endTime * TIME_TO_MILLISECONDS;
    const today = new Date();
    let isLive = false;
    if (today >= start && today < end) {
      isLive = true;
    }
    return isLive;
  };

  programData(colIndex, rowIndex) {
    if (rowIndex === -1) {
      rowIndex = 0;
    }
    let text;
    let channelsStatus;
    this.setState(
      {
        imageUrl: null,
        channelsStatus: null,
        text: null
      },
      () => {
        const tab = this.state.epgData ? this.state.epgData : null;
        const {
          applicationState: { addons }
        } = this.props;
        const title = tab?.data[rowIndex];
        const programData = tab?.data[rowIndex].events[colIndex];
        const previousProgram = tab?.data[rowIndex].events[colIndex - 1];
        const obj = programData && "images" in programData;
        let imageUrl = obj ? programData?.images[0]?.url : "";
        imageUrl = imageUrl.replace(".com/", ".com/742w/");
        channelsStatus = title?.isAddonContent;

        let slugName = title?.parent_slug ? title?.parent_slug : title?.slug;
        slugName = slugName.indexOf("|") > -1 ? slugName.split("|")[0] : slugName;
        const { displayName, action } = getInActiveSubscriptionDisplayName.call(this, title);
        let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, slugName, title.subscription);

        const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
          this,
          isUserSubscribedToAsset,
          slugName,
          title.subscriptionPerCountry
        );
        const subscriptionDisplayName = getBuyBrandsActivateDisplayName(addons, multiTaggedAddOnContent);
        let displayText = isChampionsTrophyAddOn(slugName)
          ? `${i18n.get(`pages.livePage.${action}`)} ${displayName}`
          : `${i18n.get(`pages.livePage.activate`)} ${subscriptionDisplayName}`;
        text = channelsStatus === false ? displayText : text;

        this.setState({
          channelTitle: title,
          program: programData,
          previousProgram: previousProgram,
          imageUrl: imageUrl,
          text: text,
          channelsStatus: channelsStatus
        });
      }
    );
  }

  closeModal() {
    this.props.stateActions.hideGlobalModal();
    this.state.focusOn === epgGridName && this.props.setFocus(epgGridName);
    this.state.focusOn === epgListName && this.props.setFocus(epgListName);
    if (getAppState().signupPromptActive) {
      this.props.setFocus(epgGridName);
      getAppState().signupPromptActive = false;
    }
  }

  async handleEpgKeyPress() {
    const { location } = this.props;
    const events = this.state.epgData.data[location?.state?.rowIndex]?.events[location?.state?.colIndex];
    if (events?.streamingUrl) {
      const addOn = this.state.epgData.data[location?.state?.rowIndex].parent_slug
        ? this.state.epgData.data[location?.state?.rowIndex].parent_slug
        : this.state.epgData.data[location?.state?.rowIndex].slug;
      await this.playHandler(addOn);
    }
  }

  getDataToSentBuyAsset(videoData = null) {
    return {
      title: videoData.title,
      addonContent: videoData.addonContent,
      titleId: videoData.id,
      price: null,
      isChampionsTrophyAddOn: isChampionsTrophyAddOn(videoData.addonContent)
    };
  }

  /** Player Handler deciding user is able to  watch the contents, if yes allows to play
   * other wise shows login/subscription/error overlay.
   * */
  async playHandler(addOn) {
    let videoData = null;
    if (this.state.hasMediaContentId) {
      videoData = this.getVideoDataForLiveCarousel();
    } else {
      videoData = await this.getVideoDataForEPG(isSuitableFor4KPlayback(has4KProgramId.call(this)));
    }

    const {
      applicationState: { userLogged, userAccountStatus, addons },
      stateActions
    } = this.props;
    videoData.addonContent = addOn;
    let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, videoData.addonContent, videoData.subscription);

    const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
      this,
      isUserSubscribedToAsset,
      videoData.addonContent,
      videoData.subscriptionPerCountry
    );
    videoData.addonContent = multiTaggedAddOnContent;
    isUserSubscribedToAsset = isUserSubscribedToChannel(addons, videoData.addonContent, videoData.subscription);
    if (userLogged) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(videoData.addonContent)) {
        return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
      }
      if (!isUserSubscribedToAsset) {
        return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
      }

      const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, videoData.addonContent);
      if (!isThisDeviceSupported) {
        return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
      }

      if (!!getAppState().isOnline) {
        await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
      } else {
        stateActions.showGlobalModal(
          getConfigForModalWithCloseButton(
            {
              title: i18n.get("global.errors.internetConnectivity.title"),
              text: i18n.get("global.errors.internetConnectivity.text")
            },
            this.closeModal.bind(this)
          )
        );
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }

  /** Preparing Videodata for LiveCarousel */

  getVideoDataForLiveCarousel = () => {
    const moduleIndex = 0;
    const module = this.state.modules.modules[moduleIndex];
    const { id: moduleId } = module;
    const videoData = carousalSlider.handleAction();
    videoData.moduleId = moduleId;
    videoData.contentType = "SVOD";
    videoData.onlineContent = "online";
    return videoData;
  };

  /** Preparing Videodata for EPG program */

  getVideoDataForEPG = async is4K => {
    const { location } = this.props;
    let videoData = {};
    const events = this.state.epgData.data[location?.state?.rowIndex].events[location?.state?.colIndex];
    const channelDetails = this.state.epgData.data[location?.state?.rowIndex];
    const titleData = await sdk.mediaManager.getTitle(channelDetails.id);
    const startTime = events.tsStart * TIME_TO_MILLISECONDS;
    const endTime = events.tsEnd * TIME_TO_MILLISECONDS;
    const today = new Date();
    const isUpNext = today <= startTime && today < startTime;
    const contentOwnership =
      channelDetails.contentOwnership && channelDetails.contentOwnership.length > 0
        ? channelDetails.contentOwnership[0]
        : STARZ;
    if (!isUpNext) {
      if (events && channelDetails) {
        videoData = {
          videoType: "movie",
          // Dash Widevine is on index 0
          // HLS Playreadey is on index 1
          manifest: events.streamingUrl[0].url, // getting mpd dash url
          contentTypeYoubora: "movie",
          //hardcoded pid
          releasePid: ["kReBER7kBh1T"],
          releaseUrl: "http://link.theplatform.eu/s/qaJAph/kReBER7kBh1T",
          duration: events.duration,
          adsCountryRights: today >= startTime && today < endTime ? titleData.adsCountryRights || [] : [],
          dash_widevine_ads:
            today >= startTime && today < endTime
              ? titleData.mediaContent[0].content.video.dash_widevine_ads || []
              : [],
          filmstrip: undefined,
          guid: events.guid,

          contentType: channelDetails.paid ? "SVOD" : "AVOD",
          contentOwnership,
          profileType: getAppState().currentProfileType,

          onlineContent: "online",
          title: events.title,
          description: events.description,
          playbackTime: 0,
          id: channelDetails.id.toString(),
          has4K: is4K,
          externalSubtitles: {},
          addonContent:
            today >= startTime && today >= endTime
              ? channelDetails.parent_slug || "starz"
              : channelDetails.parent_slug
              ? channelDetails.parent_slug
              : channelDetails.slug,
          isLive: today >= startTime && today < endTime ? true : false,
          subscription: channelDetails.subscription || [],
          subscriptionPerCountry: channelDetails.subscriptionPerCountry || {}
        };
      }
    }
    return videoData;
  };

  /** Deciding which content to play */

  async play(is4K) {
    if (this.state.hasMediaContentId) {
      const videoData = await this.getVideoDataForLiveCarousel();
      const { id, progress, seriesId, moduleId, is4K, contentType } = videoData;
      const titleData = await sdk.mediaManager.getTitle(id);
      Object.assign(videoData, {
        adsCountryRights: titleData.adsCountryRights || [],
        dash_widevine_ads: titleData.mediaContent[0].content.video.dash_widevine_ads || []
      });
      this.isExiting = true;
      sessionStorage && sessionStorage.setItem("fromEpg", "no");
      redirectTo.call(this, routes.player, {
        playFrom: "cw_home",
        videoConfig: { id, progress, seriesId, moduleId, is4K, contentType }
      });
    } else {
      const videoData = await this.getVideoDataForEPG(is4K);
      if (Object.keys(videoData).length !== 0) {
        Object.assign(videoData, { playFrom: PLAY_FROM_LABEL });
        //isSelectedFromResolutionPopup && trackEvent(PAGE, is4K ? "4K" : "HD", titleId);
        sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
        sessionStorage && sessionStorage.setItem("fromEpg", "yes");
        this.goPlayer(videoData);
      }
    }
  }

  /** Routing to player with valid video data */

  goPlayer(videoData) {
    const { history } = this.props;
    this.isExiting = true;
    return redirectTo.call(this, routes.player, {
      ...history.location.state,
      ...videoData
    });
  }

  onChangeItem(index) {
    if (this.props.applicationState.currentFocus === epgListName) {
      this.setState({ carousalListIndex: index });
    }
    this.props.stateActions.setCarouselItemFocus(index);
  }

  navigateLeft(e) {
    if (this.props.applicationState.focusedCarouselItemIndex === 0) {
      this.props.setFocus(headerFocusPath);
      this.isliveCarosals = false;
      this.setState({ forceRender: new Date() });
      this.props.stateActions.setLastFocusedName(epgListName);
      return;
    }
    if (this.props.applicationState.currentFocus === epgListName) carousalSlider.left();
    this.setState({ isWheel: false });
  }
  navigateRight(e) {
    if (this.props.applicationState.currentFocus === epgListName) carousalSlider.right();
    this.setState({ isWheel: false });
  }

  onLoad({ startIndex }) {
    epgStartIndex = startIndex;
  }
  onChange({ selectedliveTvList, colIndex, rowIndex }) {
    currentEPGColumnIndex = colIndex;
    if (getAppState().globalModal || this.state.isExiting === true) return;
    const { history, location } = this.props;
    // when on epg
    if (location?.state?.scrollToPage === 2 && this.state.epgData?.data?.length > 0) {
      this.props.setFocus(epgGridName);
      this.programData(colIndex, rowIndex);
      history.replace({
        state: {
          selectedliveTvList: selectedliveTvList,
          rowIndex: rowIndex,
          colIndex: colIndex,
          scrollToPage: location?.state?.scrollToPage
        }
      });
    } else if (location?.state?.scrollToPage === 0) {
      this.props.setFocus(epgListName);
    }
  }
  // * Render Components based on modules */

  rowRenderer({ key, index, parent, style }) {
    const that = this;
    const carouselLayout = (module, moduleIndex) => (
      <this.TypedCarouselStyledMemo
        title={i18n.get("global.sections.live")}
        key={module?.id}
        forceRender={that.state.forceRender}
        type={module?.type?.toLowerCase() === "livechannels" ? "LiveChannels" : "layout"}
        items={getTitlesFormattedForCarousels.call(this, module?.type, module?.titles)}
        carouselIndex={0}
        initialSlide={0}
        className={this.isliveCarosals && "focused"}
        focusPath={epgListName}
        onRef={ref => (carousalSlider = ref)}
        onChangeItem={this.onChangeItem}
        MagicRemoteStatus={this.wheelState === "active" ? true : false}
        showArrows={this.wheelState === "active" ? true : false}
        slideMargin={Theme.components.carousel.slideMargin.layout}
        direction={i18n.getDirection()}
        style={style}
        isHero={module?.type?.toLowerCase() === "livechannels" && true}
      />
    );
    const getLayoutRow = index => {
      const module = this.state.modules?.modules[index];
      if (module?.type?.toLowerCase() === "livechannels") {
        return carouselLayout(module, index);
      } else return emptyLayout();
    };
    const emptyLayout = () => {
      return <></>;
    };
    return (
      this.isEnabled() && (
        <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
          {getLayoutRow(index)}
        </CellMeasurer>
      )
    );
  }

  render() {
    const { location, history } = this.props;
    const { modules } = this.state;

    if (location?.state?.scrollToPage === undefined) {
      history.replace({
        state: {
          scrollToPage: -1
        }
      });
    }

    return this.state.loading ? (
      <Loading overlay opacity="0" />
    ) : (
      <WrapperStyled
        onWheel={e => {
          this.setState({ isWheel: true });
          this.scrollUpDown(e, false);
        }}
      >
        <>
          {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
            <ModalSettings
              headingText={i18n.get("global.modals.exit.title")}
              mainText={i18n.get("global.modals.exit.text")}
            >
              <ButtonModalFocus
                label={i18n.get("global.no").toUpperCase()}
                focusPath="noOkModal_passThru"
                onEnterPress={this.closeConfirmModal}
                onMouseUp={this.closeConfirmModal}
                size="small"
                spacing="small"
                onRef={ref => (this.confirmModalFocusPath = ref)}
                dataSnDown={"@okModal_passThru"}
                dataSnUp={""}
                dataSnLeft={""}
                dataSnRight={""}
                displayBlock={true}
              />
              <ButtonModalFocus
                label={i18n.get("global.yes").toUpperCase()}
                focusPath="okModal_passThru"
                onEnterPress={getSdk().systemManager.application.exit}
                onMouseUp={getSdk().systemManager.application.exit}
                size="small"
                dataSnUp={"@noOkModal_passThru"}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
                displayBlock={true}
              />
            </ModalSettings>
          )}
          <LayoutWrapperStyled>
            <LayoutStyled
              isVisible={location?.state?.scrollToPage > -1}
              position={resolution.layout.positionHeaderVisible}
            >
              {location?.state?.scrollToPage <= 0 && modules && this.state.showLiveCarousel && (
                <ListFocus
                  height={resolution.live.rowHeight}
                  width={width}
                  onClickPoster={i => this.onClickPoster(i, "live")}
                  rowHeight={
                    sessionStorage.getItem("fromEpg") === "yes" ? resolution.live.rowHeight : this.cache.rowHeight
                  }
                  rowRenderer={this.rowRenderer}
                  rowCount={1}
                  columnCount={1}
                  deferredMeasurementCache={this.cache}
                  autoContainerWidth
                  scrollToAlignment={"center"}
                  style={{ overflowY: "hidden", direction: "inherit" }}
                  overscanRowCount={1}
                  scrollingResetTimeInterval={0}
                  onLeft={i18n.getDirection() === directions.LEFT_TO_RIGHT ? this.navigateLeft : this.navigateRight}
                  onRight={i18n.getDirection() === directions.LEFT_TO_RIGHT ? this.navigateRight : this.navigateLeft}
                  focusPath={epgListName}
                  onEnterPress={this.enterHandler}
                />
              )}
              {location?.state?.scrollToPage === 2 && (
                <StyledPage
                  className="fixHeight"
                  onWheel={e => {
                    this.setState({ isWheel: true });
                    this.scrollUpDown(e, true);
                  }}
                >
                  {this.state.program && (
                    <>
                      <LiveHero
                        programInfo={i18n.get("pages.livePage.eventStatus")}
                        programTitle={this.state.program}
                        programData={this.programStatus(
                          this.state.program.tsStart,
                          this.state.program.tsEnd,
                          this.state.program.title,
                          this.state.previousProgram
                        )}
                        timeReming={remainingTime}
                        progress={progress}
                        imageUrl={this.state.imageUrl}
                        textInActive={this.state.text}
                        channelsStatus={this.state.channelsStatus}
                      />
                    </>
                  )}
                </StyledPage>
              )}
              <div
                onClick={i => this.onClickPoster(i, "epg")}
                onWheel={e => {
                  this.setState({ isWheel: true });
                  this.scrollUpDown(e, true);
                }}
              >
                {this.state.epgData && this.state.epgData.data.length !== 0 ? (
                  <Epg
                    forceRender={this.state.forceRender}
                    data={this.state.epgData}
                    selectedliveTvList={location?.state?.selectedliveTvList ?? 0}
                    onChange={this.onChange}
                    onLoad={this.onLoad}
                    programType={i18n.get("pages.livePage.eventStatus")}
                    //When component mounts first, isLiveCarousels is true, so check either it or selectedLiveTVIndex
                    className={
                      (!this.isliveCarosals ||
                        location?.state?.selectedliveTvList >= 0 ||
                        this.state.selectedliveTvList === -1) &&
                      "selected"
                    }
                    direction={i18n.getDirection()}
                    maxChannelShows={this.state.epgData.total > 4 ? 3 : this.state.epgData.total}
                    currentFocus={this.props.applicationState.currentFocus}
                    timeToStart={this.state.startFrom}
                    getCurrentDate={this.state.program ? this.state.program.tsStart : getUnixTime(new Date())}
                    totalTime={TOTAL_TIME_HOURS}
                    onRef={item => (this.item = item)}
                    MagicRemoteStatus={
                      this.props.applicationState.currentFocus === epgGridName && this.wheelState === "active"
                        ? true
                        : false
                    }
                    ref={this.epgEvents}
                    secondToPixelOffset={SECONDS_PER_PIXELS}
                    epgStartTime={this.state.startFrom}
                    currentFilter={this.state.currentFilter}
                    epgDictionary={this.state.epgDictionary}
                  />
                ) : (
                  this.isEpgRefreshed !== true && (
                    <LayoutEmptyStyled>
                      <strong>
                        <Text text={i18n.get("pages.livePage.noData.emptyDataMsg")} />
                      </strong>
                      <Text text={i18n.get("pages.livePage.noData.emptyDataSubMsg")} />
                    </LayoutEmptyStyled>
                  )
                )}
              </div>
            </LayoutStyled>
          </LayoutWrapperStyled>
        </>
      </WrapperStyled>
    );
  }
}

const Component = withAppState(withSubtheme(Live));
Component.defaultFocusPath = epgGridName;
export default Component;
